import { getDefaultRequestFields } from 'stores/adapters';
import { mapOmnitureData } from 'stores/adapters/bex-api/search/search-results-adapter';
export const adaptPropertySearch = bexApiResults => {
  var _a, _b, _c, _d;
  if (!((_a = bexApiResults === null || bexApiResults === void 0 ? void 0 : bexApiResults.data) === null || _a === void 0 ? void 0 : _a.propertySearch)) {
    return {};
  }
  const {
    data: {
      propertySearch
    },
    extensions
  } = bexApiResults;
  const {
    summary
  } = propertySearch;
  const loyaltyInfo = summary && summary.loyaltyInfo;
  return {
    defaultRequestFields: propertySearch.criteria && getDefaultRequestFields(propertySearch.criteria, ((_c = (_b = propertySearch === null || propertySearch === void 0 ? void 0 : propertySearch.shoppingContext) === null || _b === void 0 ? void 0 : _b.multiItem) === null || _c === void 0 ? void 0 : _c.id) || '', bexApiResults) || undefined,
    propertySearchListings: propertySearch.propertySearchListings,
    propertyListingAdaptexAnalyticsSuccessEvents: (_d = propertySearch.propertyListingAdaptexAnalyticsSuccessEvents) !== null && _d !== void 0 ? _d : [],
    loyaltyMessagingModel: loyaltyInfo,
    multiItemSearchContext: propertySearch.multiItemSearchContext || undefined,
    omnitureData: [mapOmnitureData(extensions.analytics)],
    resultMessages: summary.resultMessages,
    messagingModule: summary.messagingModule || undefined,
    resultsHeading: summary.resultsHeading || undefined,
    totalPropertyCount: summary.matchedPropertiesSize,
    errorResponse: propertySearch.errorResponse || undefined,
    dialogErrorResponse: propertySearch.dialogErrorResponse || undefined,
    pagination: propertySearch.pagination || undefined,
    mapTrigger: propertySearch.mapTrigger || undefined,
    dynamicMap: propertySearch.dynamicMap || undefined
  };
};